import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  span: {
    color: theme.colorScheme === 'dark' ? theme.white : theme.colors.dark[9],
  },
}));
